import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ICON } from '@core/util/icon';
import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { Store } from '@ngxs/store';
import { BusinessDispatch, BusinessState } from '@state/business';
import { BaseBusinessSettingsSection } from '../business-finances-general/common/base-business-settings-section/base-business-settings-section.directive';

@Component({
	selector: 'app-instrument-registration-settings',
	templateUrl: './instrument-registration-settings.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class InstrumentRegistrationSettingsComponent extends BaseBusinessSettingsSection {
	ICON = ICON;
	locationFieldPath = 'teraview.feeSettings.location';
	DirectionOfFeeType = DirectionOfFeeType;

	private businessDispatch = inject(BusinessDispatch);
	private store = inject(Store);

	public settings_ = this.store.selectSignal(
		BusinessState.getDefaultTeraviewFeeSettings,
	);

	setSplitBetweenTlAndSoa(value: boolean) {
		this.toggleSetting(value, 'splitBetweenTlAndSoa');
	}

	setCombineExemptAndEregFees(value: boolean): void {
		if (value) {
			this.businessDispatch.OverwriteBusinessFields(
				'defaultSettings.teraview.feeSettings',
				{
					...this.settings_(),
					combineExemptAndEregFees: true,
					splitBetweenTlAndSoa: false,
				},
			);
		} else {
			if (this.settings_()?.combineExemptAndEregFees) {
				this.resetSettingsToDefaults();
			} else {
				this.businessDispatch.OverwriteBusinessFields(
					'defaultSettings.teraview.feeSettings.combineExemptAndEregFees',
					false,
				);
			}
		}
	}

	private resetSettingsToDefaults(): void {
		this.businessDispatch.OverwriteBusinessFields(
			'defaultSettings.teraview.feeSettings',
			{
				combineExemptAndEregFees: false,
				splitBetweenTlAndSoa: false,
				hst: false,
				location: DirectionOfFeeType.SOA,
			},
		);
	}

	setHst(value: boolean): void {
		this.toggleSetting(value, 'hst');
	}

	private toggleSetting(
		value: boolean,
		field: 'combineExemptAndEregFees' | 'splitBetweenTlAndSoa' | 'hst',
	) {
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.teraview.feeSettings.${field}`,
			value,
		);
	}
}
